import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

export const InsightsIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon sx={{fill: "none", strokeWidth: "1.5", ...props.sx}} viewBox="0 0 19 19">
        <path
            d="M1 0V18H19M5.65789 10.3084V15.1454M9.52632 15.1454V8.80176M13.3158 15.1454V11.4978M17.2632 15.1454V6.74009M4.64306 7.5L9.52632 2.61674L13.3158 6.42291L17.2632 2.45815"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);
